import {
  icon
} from "./chunk-LJ27NVUA.mjs";

// src/icon/src/SVGIcon.tsx
import { ScreenReaderOnly } from "@thisisbud/gds-shared-utilities";
import { jsx, jsxs } from "react/jsx-runtime";
var SVGIcon = ({ label, children, category, size = "sm" }) => /* @__PURE__ */ jsxs(
  "span",
  {
    className: icon({
      category,
      className: "rounded"
    }),
    children: [
      /* @__PURE__ */ jsx(ScreenReaderOnly, { show: Boolean(label), children: label }),
      /* @__PURE__ */ jsx(
        "svg",
        {
          "aria-hidden": "true",
          fill: "none",
          height: icon({ size }),
          pointerEvents: "none",
          role: "img",
          viewBox: `0 0 ${icon({ size })} ${icon({ size })}`,
          width: icon({ size }),
          xmlns: "http://www.w3.org/2000/svg",
          children
        }
      )
    ]
  }
);
var GeneralIcon = ({
  label,
  children
}) => /* @__PURE__ */ jsx(SVGIcon, { label, size: "sm", children });
var CategoryIcon = ({
  label,
  category = "plain",
  children
}) => /* @__PURE__ */ jsx(SVGIcon, { category, label, size: "md", children });

export {
  GeneralIcon,
  CategoryIcon
};
